/**
 *
 * Switch
 *
 */

import React from 'react';
import { Switch as CustomSwitch } from 'antd';

const Switch = ({ ...rest }) => {
  return <CustomSwitch {...rest} />;
};

export default Switch;
